const primary = '#8a1e25';
export default {
    primary,
    light: {
        'strong-text': '#101010',
        surface: '#ffffff',
        muted: '#7c7c7c',
        appbg: '#ffffff',
        ebadge: '#ed5757',
        text: '#313131',

        primary,
        appmenubg: '#46080c',
        secondary: '#ffb606',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    }
}